import { render } from "./iframeDialog.vue?vue&type=template&id=beb84bb0&scoped=true"
import script from "./iframeDialog.vue?vue&type=script&lang=js"
export * from "./iframeDialog.vue?vue&type=script&lang=js"

import "./iframeDialog.vue?vue&type=style&index=0&id=beb84bb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb84bb0"]])

export default __exports__